import type { ComponentType } from 'react';

import { isPPLFrontend } from './app-paths';

/**
 * Approach 1: Build-time HoC using `isPPLFrontend` flag
 * This creates a wrapper that conditionally renders the component based on build-time flags.
 * Only PRO tenants should see the component.
 */
export function withPROGuard<T extends {}>(Component: ComponentType<T>): ComponentType<T> {
  return function PROGuardedComponent(props: T) {
    // Use build-time flag for tree-shaking
    if (isPPLFrontend) {
      return null;
    }

    return <Component {...props} />;
  };
}
